module.exports = __webpack_public_path__ + "media/images/responsive/fairs/event_detail/photo_experience-7eeefb1726e756f87487a2419b9ab558.jpg";